<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import { useAnalysisStore } from '@/store/modules/analysis'
import {
  splitBySentence,
  transformMarkedText,
} from '@/composables/splitSentence'
import PersonalSpiderChart from './PersonalSpiderChart.vue'
import PersonalStrWea from './PersonalStrWea.vue'
import { useParsedStWeText } from '@/composables/useParsedStWeText.js';

const props = defineProps({
  pData: Object,
  userName: String,
  isMobile: Boolean,
})
const store = useAnalysisStore()
onMounted(() => {
})

const rawChartDesc = computed(() => splitBySentence(props.pData.기운방향상세.결과요약))

const rawStWeData = computed(() => props.pData.기운방향상세.상세해석)
const {
  parsedStrengthMain,
  parsedStrengthDetail,
  parsedWeaknessMain,
  parsedWeaknessDetail,
} = useParsedStWeText(rawStWeData)

// 차트데이터
const chartData = computed(() => props.pData.기운방향상세.특성통계)
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="personality-wrapper">
          <div class="person-desc-box">
            <div class="desc__title">
              🧭 이런 흐름으로 나의 성향이 향하는 방향을 종합해볼 수 있어요.
            </div>
            <div class="person-spider-wrapper">
              <PersonalSpiderChart 
                :chartData="chartData"
                :isMobile="isMobile"
              />
            </div>
          </div>

          <div class="person-content-box">
            <div v-for="(sentence, idx) in rawChartDesc" :key="idx">
              <span class="content__body-txt">
                <div 
                v-html=" transformMarkedText(sentence)"
                />
              </span>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper">
          <div class="person-desc-box">
            <div class="desc__title">🤗 이런 면모들이 나를 더 입체적으로 보여줘요.</div>
            <div class="desc__body">
              <PersonalStrWea
                :firstKeyword="props.pData.기운방향상세.강점약점[0]"
                :secondKeyword="props.pData.기운방향상세.강점약점[1]"
                :isMobile="isMobile"
              />
              <div class="desc__body-highlight">
                <div
                  :key="'sm' + idx"
                  class="content__body-txt"
                  v-html="parsedStrengthMain"
                />
              </div>
              <div class="desc__body-padd">
                <div
                  :key="'sm' + idx"
                  class="content__body-txt"
                  v-html="parsedStrengthDetail"
                />
              </div>

              <div v-if="parsedWeaknessMain.length > 0" class="desc__body-gray">
                <div
                  :key="'sm' + idx"
                  class="content__body-txt"
                  v-html="parsedWeaknessMain"
                />
              </div>

              <div class="desc__body-padd">
                <div
                  :key="'sm' + idx"
                  class="content__body-txt"
                  v-html="parsedWeaknessDetail"
                />
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
